module.exports = __webpack_public_path__ + "static/media/home-banner-img-3.994f92b0.jpg";